import { render, staticRenderFns } from "./CallSupport.vue?vue&type=template&id=0ab10c3f&scoped=true"
import script from "./CallSupport.vue?vue&type=script&lang=js"
export * from "./CallSupport.vue?vue&type=script&lang=js"
import style0 from "./CallSupport.vue?vue&type=style&index=0&id=0ab10c3f&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0ab10c3f",
  null
  
)

export default component.exports